import RoadMapGeneric from "../components/Roadmaps/RoadMapGeneric";
import { roadA1Juan } from "../utils/roadA1Juan";

const RoadMapJuan = (props) => <RoadMapGeneric {...props} roadData={roadA1Juan} />;
export default RoadMapJuan;